import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {DialogWidth, ThemePalette, UserTeam} from '@q9elements/ui-kit/common';
import {ConfirmModalDialogComponent} from '@q9elements/ui-kit/components';

@Injectable({
  providedIn: 'root'
})
export class SpaceNavigationDialogsService {
  constructor(private dialog: MatDialog) {}

  public handleSuspendedSpace(space: UserTeam) {
    return this.dialog
      .open(ConfirmModalDialogComponent, {
        width: DialogWidth.SM,
        disableClose: true,
        data: {
          modalTitle: 'TEAMS.TEAM_IS_SUSPENDED',
          content: space.teamAdmin
            ? 'TEAMS.SUSPENDED_FOR_ADMIN'
            : 'TEAMS.SUSPENDED_FOR_VIEWER_EDITOR',
          showCancelButton: false,
          confirmText: 'TEAMS.SUSPENDED_OK',
          color: ThemePalette.PRIMARY,
          closeAfterError: true
        }
      })
      .afterClosed();
  }
}
